import { useContext, useEffect, useState } from 'react';
import './cancellation.styles.scss';
import { Outlet, useLocation } from 'react-router-dom';
import { CancelContext } from '../../contexts/cancellation.context';
import { getCookie } from '../../utils/generaFunctions';
import { checkInfo } from '../../utils/recurly.functions';

const Cancellation = () => {
    const location = useLocation();
    const urlParams = new URLSearchParams(location.search);
    const {userInfo, loading, changeUserInfo, setLoading} = useContext(CancelContext);
    const email = urlParams.has("email")?urlParams.get("email"):userInfo.email;
    const address = urlParams.has("address")?urlParams.get("address"):userInfo.address;
    const [constFinished, setConstFinished] = useState(false);
    useEffect(() => {
        if(constFinished && getCookie("cancellation-"+email) && !location.pathname.includes("/canceled") && !location.pathname.includes("/keep") && !location.pathname.includes("confirmed")&& !location.pathname.includes("paused")){
            alert("session expired");
            window.location.href = '/';
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location, constFinished]);
    useEffect(()=>{
        setLoading(true);
        if (!email || !address) {
            setTimeout(() => {
                //changeUserInfo({"email": "nick_test@test.ca", "address":"US, CA", "check":true,"token":"kB36ztoCJuojmKD6bHfJnV8WLgiRjzbc","box_seq":"1-2-9-4-5-6-3-15","name":"DEV Mode","addons":"us-shipping,promo-ttm50","unit_price":35,"plan_code":"ttm-3mbb-e1m","next_renewal":"2024-02-18T19:16:53Z","total":42.95,"wed_date":"2024-11-23","active":true,"pause":false});
                window.location.href = '/';
                //setLoading(false);
                //setConstFinished(true);
            }, 1000)
          } else {
            checkInfo(email, address, true).then((response)=>{
                if (response.check && response.plan_code.includes("ttm") && response.active) {
                    changeUserInfo({...response, "email":email, "address":address});
                    setConstFinished(true);
                    setLoading(false);
                    //Recurly
                } else {
                  window.location.href = "/";
                }
            });
          }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])
    return (
        <div className={`cancellation-container ${loading ? "loading" : ""}`}>
            <Outlet></Outlet>
        </div>
    )
}

export default Cancellation;